import { BaseInputConfig, FormInputType } from '@mss/mss-component-library';
import React from 'react';
import {
  BrandSelector,
  CriticalitySelector,
  CustodianSelector,
  HistoricalMessagesCollectionGroup,
  LocationSelector,
  NumberInput,
  OPCServerGroupSelector,
  PasswordInput,
  RoleSelector,
  SelectInput,
  SeriesSelector,
  StringInput,
  SwitchInput,
  TextAreaInput,
  TimezoneSelector,
} from '../Shared/Inputs';

export const inputTypeComponent: Record<
  FormInputType,
  (props: any) => React.ReactElement
> = {
  switch: SwitchInput,
  string: StringInput,
  number: NumberInput,
  password: PasswordInput,
  text: TextAreaInput,
  custodian: CustodianSelector,
  role: RoleSelector,
  criticality: CriticalitySelector,
  location: LocationSelector,
  timezone: TimezoneSelector,
  hmcg: HistoricalMessagesCollectionGroup,
  select: SelectInput,
  brand: BrandSelector,
  series: SeriesSelector,
  opc_server_group: OPCServerGroupSelector,
};

type MapperArgs = {
  index: number;
  disabled?: boolean;
  fieldNamesToIgnore?: string[];
  compact?: boolean;
  copyButton?: boolean;
  subType?: { key: string; value: string };
};

export function mapInputToJSX({
  index,
  disabled,
  fieldNamesToIgnore,
  compact,
  copyButton,
  subType,
}: MapperArgs) {
  return function Input(input: BaseInputConfig) {
    const Component = inputTypeComponent[input.type as FormInputType];

    if (fieldNamesToIgnore?.includes(input.fieldName)) return null;
    return (
      <Component
        key={input.fieldName}
        {...input}
        subType={subType}
        copyButton={copyButton}
        compact={compact}
        index={index}
        disabled={!!disabled}
        autoComplete={input.type}
      />
    );
  };
}
